<template>
  <div class="page">
    <div v-if="loading" class="hint">{{ loadingText }}</div>
    <template v-else-if="showPicker">
      <div class="hero">
        <div class="title">选择支付商户</div>
        <div class="sub">请选择本次收款的商户</div>
      </div>
      <div v-if="error" class="hint err">{{ error }}</div>
      <div v-else-if="!list.length" class="hint">暂无已开通的收款商户</div>
      <div
        v-for="item in list"
        :key="item.itemId"
        class="card"
        :class="{ busy: pickingId === item.itemId }"
        @click="pick(item)"
      >
        <div class="logo-col">
          <div class="logo-wrap">
            <img v-if="item.channelLogo" class="logo" :src="item.channelLogo" alt="" />
            <div v-else class="logo ph">{{ (item.channelName || '支').slice(0, 1) }}</div>
          </div>
          <div class="ch-name">{{ item.channelName }}</div>
        </div>
        <div class="main">
          <div class="name-row">
            <span class="name">{{ item.mchName }}</span>
          </div>
          <div class="auth-row">
            <span class="auth" :class="item.wxAuth ? 'is-ok' : 'is-no'">
              <img class="ico" src="https://agent.fskeeper.com/img/微信.png" alt="微信" />
              <span>{{ item.wxAuth ? '已认证' : '未认证' }}</span>
            </span>
            <span class="auth" :class="item.aliAuth ? 'is-ok' : 'is-no'">
              <img class="ico" src="https://agent.fskeeper.com/img/支付宝.png" alt="支付宝" />
              <span>{{ item.aliAuth ? '已认证' : '未认证' }}</span>
            </span>
          </div>
        </div>
        <div class="arrow">›</div>
      </div>
    </template>
    <div v-else-if="error" class="hint err">{{ error }}</div>
  </div>
</template>

<script>
import { getMicroPayEntry, listMicroPayMerchants, selectMicroPayMerchant } from '@/api/api'
import { resolveMicroChannel } from '@/utils/channelIcon'
import config from '@/config'
import { saveMicroSelectUrl, clearMicroSelectUrl, goHubWithToken, keepCurrentOrigin } from '@/utils/microSelect'

export default {
  name: 'MicroSelect',
  data () {
    return {
      loading: true,
      loadingText: '正在进入收银台...',
      error: '',
      list: [],
      pickingId: 0,
      showPicker: false
    }
  },
  created () {
    const token = this.$route.params[config.urlTokenName] || config.cacheToken
    if (!token) {
      this.loading = false
      this.error = '请通过收款码进入'
      return
    }
    config.cacheToken = token
    this.enter(token)
  },
  methods: {
    jumpCashier (data) {
      clearMicroSelectUrl()
      const cashierToken = (data && (data.cashierToken || data.CashierToken)) || ''
      const cashierUrl = (data && (data.cashierUrl || data.CashierUrl)) || ''
      if (cashierToken) config.cacheToken = cashierToken
      if (cashierUrl) {
        window.location.replace(keepCurrentOrigin(cashierUrl) || cashierUrl)
        return
      }
      goHubWithToken(config.cacheToken)
    },
    withChannelDisplay (merchants) {
      const list = Array.isArray(merchants) ? merchants : []
      return list.map(item => {
        const channel = resolveMicroChannel(item)
        return Object.assign({}, item, { channelName: channel.name, channelLogo: channel.logo })
      })
    },
    enter (token) {
      this.loadingText = '正在进入收银台...'
      getMicroPayEntry(token).then(data => {
        const mode = data && (data.scanMode != null ? data.scanMode : data.ScanMode)
        if (Number(mode) === 1) {
          this.jumpCashier(data)
          return
        }
        saveMicroSelectUrl(window.location.href)
        const merchants = (data && (data.merchants || data.Merchants)) || []
        this.list = this.withChannelDisplay(merchants)
        this.showPicker = true
        this.loading = false
        this.error = ''
        setTimeout(() => this.fetchList(true), 2200)
      }).catch(err => {
        this.error = (err && (err.msg || err.message)) || '加载失败'
        this.loading = false
      })
    },
    fetchList (silent) {
      const token = this.$route.params[config.urlTokenName] || config.cacheToken
      listMicroPayMerchants(token).then(data => {
        this.list = this.withChannelDisplay(data)
        this.showPicker = true
        this.loading = false
        this.error = ''
        if (!silent) {
          setTimeout(() => this.fetchList(true), 2200)
        }
      }).catch(err => {
        if (silent) return
        this.error = (err && (err.msg || err.message)) || '加载失败'
        this.loading = false
      })
    },
    pick (item) {
      if (this.pickingId) return
      this.pickingId = item.itemId
      const token = this.$route.params[config.urlTokenName] || config.cacheToken
      selectMicroPayMerchant(token, item.itemId).then(res => {
        if (res && res.selectUrl) {
          saveMicroSelectUrl(res.selectUrl)
        }
        this.jumpCashier(res)
      }).catch(err => {
        this.pickingId = 0
        this.$confirm({
          title: '提示',
          message: (err && (err.msg || err.message)) || '选择失败，请重试'
        })
      })
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f3f4f6;
  padding: 0.28rem 0.32rem calc(0.56rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}
.hero {
  text-align: center;
  padding: 0.36rem 0 0.4rem;
}
.title {
  font-size: 0.52rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: 0.02em;
  line-height: 1.3;
}
.sub {
  margin-top: 0.12rem;
  font-size: 0.3rem;
  color: #8b9099;
}
.hint {
  text-align: center;
  color: #8b9099;
  font-size: 0.32rem;
  padding: 1.6rem 0.24rem;
  line-height: 1.6;
}
.hint.err { color: #e54d42; }
.card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 0.28rem;
  padding: 0.36rem 0.28rem 0.36rem 0.32rem;
  margin-bottom: 0.24rem;
  box-shadow: 0 0.08rem 0.24rem rgba(17, 24, 39, 0.04);
}
.card:active {
  background: #f8f9fb;
}
.card.busy {
  opacity: 0.65;
}
.logo-col {
  width: 1.28rem;
  flex-shrink: 0;
  text-align: center;
  margin-right: 0.28rem;
}
.logo-wrap {
  width: 1.08rem;
  height: 1.08rem;
  margin: 0 auto;
  border-radius: 0.22rem;
  background: #f4f6fa;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo {
  width: 0.78rem;
  height: 0.78rem;
  object-fit: contain;
}
.logo.ph {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #3b82f6;
  font-size: 0.44rem;
  font-weight: 700;
}
.ch-name {
  margin-top: 0.1rem;
  font-size: 0.28rem;
  color: #6b7280;
  line-height: 1.3;
}
.main { flex: 1; min-width: 0; }
.name-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
.name {
  font-size: 0.44rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.35;
}
.auth-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.18rem;
  gap: 0.16rem;
}
.auth {
  display: inline-flex;
  align-items: center;
  font-size: 0.3rem;
  font-weight: 600;
  padding: 0.06rem 0.16rem 0.06rem 0.1rem;
  border-radius: 999px;
  line-height: 1.2;
}
.auth .ico {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
}
.auth.is-ok {
  background: #edfaf3;
  color: #059669;
}
.auth.is-no {
  background: #fef2f2;
  color: #dc2626;
}
.arrow {
  flex-shrink: 0;
  margin-left: 0.08rem;
  color: #d1d5db;
  font-size: 0.56rem;
  line-height: 1;
  font-weight: 300;
}
</style>
